import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

const ROWS = 5
const COLUMNS = [
  { width: 290, skeleton: 'w-48' },
  { width: undefined, skeleton: 'w-28' },
  { width: undefined, skeleton: 'w-20', badge: true },
  { width: 60, skeleton: 'w-8' },
  { width: undefined, skeleton: 'w-16' },
  { width: undefined, skeleton: 'w-24' },
  { width: undefined, skeleton: 'w-24' },
]

const TendersTableSkeleton: React.FC = () => {
  return (
    <div>
      <div className="py-2 flex items-center">
        <Skeleton className="h-8 w-40" />
        <div className="flex-1" />
        <Skeleton className="h-8 w-36 rounded-md" />
      </div>
      <div className="rounded-md border border-border overflow-hidden bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="!w-9 !p-0" />
              {COLUMNS.map((col, i) => (
                <TableHead key={i} style={col.width ? { width: col.width } : undefined}>
                  <Skeleton className="h-3 w-20" />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: ROWS }).map((_, rowIdx) => (
              <TableRow key={rowIdx}>
                <TableCell className="!w-9 !p-0 text-center">
                  <Skeleton className="h-4 w-4 mx-auto" />
                </TableCell>
                {COLUMNS.map((col, colIdx) => (
                  <TableCell key={colIdx}>
                    <Skeleton
                      className={`h-4 ${col.skeleton} ${col.badge ? 'h-5 rounded-full' : ''}`}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div className="flex items-center justify-end py-2 px-1">
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  )
}

export default TendersTableSkeleton
